import { FontWeight } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      marginTop: 24,
    },
    heading: {
      color: '#000000',
      fontSize: '14px',
      lineHeight: '16px',
      fontWeight: FontWeight.Bold,
      marginBottom: 12,
    },
  },
  { name: 'device-filter' },
);
